import React from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Responsive from 'react-responsive';
import theme, { textBold } from 'theme/theme';
import { getIsAuthenticated, getAuthUser } from 'auth/store/auth/selectors';
import { logout } from 'auth/store/auth/actions';
import SearchInput from 'search/containers/SearchInput';
import Online from 'offline/containers/Online/Online';
import { MenuIcon } from 'base/components/Icon';
import logo from 'assets/images/bucher-logo.png';
import { toggleMobileMenu } from 'store/ui/menu/actions';
import { getMyContact } from 'contacts';
import { openModal } from 'modal';
import ProfileDropdown from 'base/components/ProfileDropdown';
import Link from 'base/components/Link';

const AppHeaderWrapper = styled.header`
  z-index: 1;
`;

const Header = styled.div`
  display: flex;
  z-index: 1;
  background: #fff;
  padding-right: 20px;
  padding-left: 0;
  box-shadow: 0 1px 5px 1px rgba(0,0,0,0.2);
  @media (min-width: ${theme.breakpoints.desktop}) {
    padding-right: 45px;
    padding-left: 0;
  }
`;

const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 25px;
  @media (min-width: ${theme.breakpoints.desktop}) {
    padding: 20px 25px;
  }
`;

const SubHeader = styled.div`
    display: flex;
    position:relative;
    background: ${theme.colors.darker};
    padding: 10px 22px 
`;

const MobileMenuTrigger = styled.div`
  display: inline-flex;
  align-items: end;
  margin-left: auto;
  text-transform: uppercase;
  font-size: ${theme.fontSizes.large};
  color:  ${theme.colors.medium};
  &:hover {
    color: ${theme.colors.white};
    cursor: pointer;
  }
`;

const BrandingWrapper = styled(HeaderSection)`
  @media (min-width: ${theme.breakpoints.desktop}) {
    width: 400px;
    ${(props) => props.withBorder && css`
      border-right: 1px solid ${theme.colors.light};
    `}
  }
`;

const Logo = styled.img`
  width: 110px;
  height: auto;
  vertical-align: top;
  @media (min-width: ${theme.breakpoints.desktop}) {
    width: 130px;
  }
`;

const Slogan = styled.strong`
  display: none;
  vertical-align: top;
  margin: 2px 0 0 20px;
  ${textBold};
  font-size: ${theme.fontSizes.small};
  text-transform: uppercase;
  line-height: 12px;
  @media (min-width: ${theme.breakpoints.desktop}) {
    display: block;
  }
  @media print {
    display: block;
  }
`;

export const Branding = ({ withBorder, style }) => (
  <BrandingWrapper withBorder={withBorder} style={style}>
    <Link to="/" href="/"><Logo src={logo} /></Link>
    <Slogan>
        Corporate
      <br />
        Intranet
    </Slogan>
  </BrandingWrapper>
);

class AppHeader extends React.Component {
  componentDidMount() {
  }

  render() {
    const {
      user, isAuthenticated, logout, toggleMobileMenu, myContact, openModal,
    } = this.props;
    return (
      <AppHeaderWrapper className="app__header">
        <Header>
          <Branding withBorder />
          {isAuthenticated && user && (
            <Responsive minWidth={theme.breakpoints.desktop}>
              <HeaderSection className="print-hide">
                <SearchInput />
              </HeaderSection>
            </Responsive>
          )}
          {isAuthenticated && user && (
            <ProfileDropdown
              className="print-hide"
              name={user.fullName}
              handleLogout={logout}
              myContact={myContact}
              openModal={openModal}
              key={JSON.stringify(myContact)}
            />
          )}
        </Header>
        {isAuthenticated && (
          <Responsive maxWidth={theme.breakpoints.desktop}>
            <Online>
              <SubHeader className="app__subheader print-hide">
                <SearchInput />
                <MobileMenuTrigger onClick={toggleMobileMenu}>
                  Menu
                  {' '}
                  <MenuIcon />
                </MobileMenuTrigger>
              </SubHeader>
            </Online>
          </Responsive>
        )}
      </AppHeaderWrapper>
    );
  }
}

AppHeader.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
  isAuthenticated: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  toggleMobileMenu: PropTypes.func.isRequired,
  myContact: PropTypes.objectOf(PropTypes.any),
  openModal: PropTypes.func.isRequired,
};
AppHeader.defaultProps = {
  user: null,
  myContact: null,
};

const mapStateToProps = (state) => ({
  isAuthenticated: getIsAuthenticated(state),
  user: getAuthUser(state),
  myContact: getMyContact(state),
});

const mapDispatchToProps = {
  logout,
  toggleMobileMenu,
  openModal,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppHeader);
